import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CacheService } from '~Services/cache.service';

import { TypeDocumentEnum } from '~Tools/Constantes';

/**
 * Service d'utilisateur
 */
@Injectable({
  providedIn: 'root'
})
export class TypeDocumentService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient, private cacheService: CacheService) {
    }

    /**
     * Obtenir le type de document
     * @param typeDocument
     */
    obtenirTypeDocument(typeDocument: TypeDocumentEnum): any {
        let httpParams = new HttpParams().set('TypeDocument', typeDocument.toString());
        let options = {
            params: httpParams
        };

        let reponse = this.http.get(`api/typedocument/obtenirtypedocument`, options).pipe(map(retour => { return retour; }));

        // Mettre en cache 1h
        let cle = `api/typedocument/obtenirtypedocument` + '_typeDocument:' + typeDocument;
        let duree = 60 * 60 * 1000;
        return this.cacheService.Obtenir(reponse, cle, duree);
    }
}
